import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";

const Counter = ({ current, total }) => {
  return (
    <div className={styles["container"]}>
      <div className={styles["total-images"]}>
        <div className={`${styles["character"]} ${styles["character-left"]}`}>{current}</div>
        <div className={`${styles["character"]} ${styles["separator"]}`}></div>
        <div className={styles["character"]}>{total}</div>
      </div>
    </div>
  );
};

Counter.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};

export default Counter;
